import axios from 'axios';
import config from '../environment/config';
import { authHeader } from './auth.header';
// import { authHeader } from 'services/auth.header'; 
const API_URL = config.API_URL;


export const membershipFeeInsert = async (values) => {
    try {
    if (values.subscriptionId != null && values.subscriptionId !== "") {
      const response = await axios.put( `${API_URL}subscriptions/updateSubscription`,
        values,
       { headers: authHeader() }
      );
      return response.data;      
    } else {     
        const response = await axios.post( `${API_URL}subscriptions/createSubscription`,
          values,
         { headers: authHeader() }
        );
        return response.data;
    }
    } catch (error) {
      console.error('Error occurred in membershipFeeInsert:', error);
      throw error;
    }
  };
  

  export const getmemberShipTypeList = async () => {
    try {
        return (await axios.get(`${API_URL}subscriptions/getMembershipTypeList`, {
            headers: authHeader()
        })).data;
    } catch (error) {
        console.error('Error occurred in getmemberShipTypeList', error);
        throw error; 
    }
    
};
  
export const getRegisteredUsersDetails = async () => {
  try {
      return (await axios.get(`${API_URL}registered-user-details`, {
          headers: authHeader()
      })).data;
  } catch (error) {
      console.error('Error occurred in getRegisteredUsersDetails', error);
      throw error; 
  }
  
};


export const getActiveMemberDetails = async () => {
  try {
      return (await axios.get(`${API_URL}active-member-details`, {
          headers: authHeader()
      })).data;
  } catch (error) {
      console.error('Error occurred in getActiveMemberDetails', error);
      throw error; 
  }
  
};


export const getSubscriptionCodeStatus = async (subscriptionCode) => {
  try {
    return (
      await axios.get(`${API_URL}subscriptions/fetchSubscriptionCode`, {
        headers: authHeader(),
        params: { subscriptionCode }
      })
    ).data;
  } catch (error) {
    console.error('Error occurred in getSubscriptionCodeStatus', error);
    throw error;
  }
};

export const fetchSubscriptionData = async (subscriptionId) => {
  try {
    return (
      await axios.get(`${API_URL}subscriptions/fetchSubscriptionDataById`, {
        headers: authHeader(),
        params: { subscriptionId }
      })
    ).data;
  } catch (error) {
    console.error('Error occurred in getSubscriptionCodeStatus', error);
    throw error;
  }
};
